import script from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"
export * from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"

import "./Common-resource-list.vue?vue&type=style&index=0&id=172296aa&lang=scss&scoped=true"
import "./Common-resource-list.vue?vue&type=style&index=1&id=172296aa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172296aa"]])

export default __exports__